
import { useMediaQuery } from "react-responsive";

import Card1 from './modules/card1'
import Card2 from './modules/card2'
import Card3 from './modules/card3'

const Solutions = () => {
 const isDesktop = useMediaQuery({ minWidth: 769 });

  return (
    <div style={{minHeight: '400px'}}>
      <Card1 />
      <Card2 />
      <Card3 />
    </div>
  )
}

export default Solutions